import { useEffect, useState } from 'react';

const STORAGE_KEY = 'global_ad_dismissed_v1';

export default function GlobalAd({ imageSrc = '/reklam.png', linkHref, alt = 'Reklam' }) {
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    try {
      const val = window.localStorage.getItem(STORAGE_KEY);
      setIsDismissed(val === '1');
    } catch {
      setIsDismissed(false);
    }
  }, []);

  const dismiss = () => {
    setIsDismissed(true);
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // ignore
    }
  };

  const content = (
    <div className="relative bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden w-[220px]">
      <button
        type="button"
        aria-label="Reklamı kapat"
        onClick={dismiss}
        className="absolute top-2 right-2 z-10 w-8 h-8 rounded-full bg-white/90 hover:bg-white text-gray-700 flex items-center justify-center shadow"
      >
        ×
      </button>
      <img src={imageSrc} alt={alt} className="w-full h-auto block" loading="lazy" decoding="async" />
    </div>
  );

  if (isDismissed) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[9999]">
      {linkHref ? (
        <a href={linkHref} target="_blank" rel="noreferrer" className="block">
          {content}
        </a>
      ) : (
        content
      )}
    </div>
  );
}
